import * as zod from 'zod';

export const RecipeData = zod.object({
  id: zod.string(),
  equipment_kind: zod.string().nullable().default(null),
  step_kind: zod.string().nullable().default(null),
  recipe_name: zod.string().default(''),
  settings: zod.record(zod.any()).default({}), // JSONB type for settings
  created: zod.string().default(new Date().toISOString()),
  updated: zod.string().default(new Date().toISOString()),
});

export type RecipeData = zod.infer<typeof RecipeData>;
